import config from '@/config/config';
import { get } from '@/helpers/api.helper';

const { agent_api } = config.api;

export async function getRecipeCategories() {
    try {
        const filter = '?filter=level||eq||1'
        return await get(`${agent_api}/recipe/categories${filter}`).then(r => r.data?.data || [])
    } catch (error) { throw error }
}

export async function getRecipes(categoryIds: string[], search?: string, offset?: number, limit?: number) {
    try {
        const filter = `?filter=categoryId||$in||${categoryIds.join(',')}${!!search ? `&filter=title||$cont||${search}` : ''}&offset=${offset || 0}&limit=21`
        const fields = 'fields=id,title,thumbnail'
        if (categoryIds.length === 0) {
            return await get(`${agent_api}/recipe/posts?${!!search ? `filter=title||$cont||${search}&` : ''}${fields}&offset=${offset || 0}&limit=21`).then(r => r.data?.data || [])
        }
        return await get(`${agent_api}/recipe/posts${filter}&${fields}`).then(r => r.data?.data || [])
    } catch (error) { throw error }
}

export async function getRecipeDetail(recipeId: string) {
    try {
        return await get(`${agent_api}/recipe/posts?filter=id||eq||${recipeId}`).then(r => r.data?.data || [])
    } catch (error) { throw error }
}